import React, { useState, useEffect, useRef, useCallback } from "react";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../../style.scss";
import { currencies } from "../../../../../../../static/currencies";
import { useAppContext } from "../../../../../../../AppContext";
import { useLocation, useParams } from "react-router-dom";
import { formatDate } from "../../../../../../formatDate";

function EditGroup() {
  const { user, chimeraserv, components } = useAppContext();
  const props = { user, chimeraserv, components };
  const [selectedCurrency, setSelectedCurrency] = useState(currencies[0]);
  const [reset, setReset] = useState(new Date().getTime());
  const [title] = useState("Edit Client | Chimera Solutions | Insights");
  const [form, setForm] = useState({ state: null, message: "" });
  const { id } = useParams();
  const location = useLocation();
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(false);
  const [field, setField] = useState({
    name: { value: "nil", message: "", state: null },
    levels: {
      value: [{ id: 1, name: "Admin", state: true }],
      message: "",
      state: true,
    },
    accntExp: { value: new Date(), message: "", state: true },
  });

  const time = useRef(null);

  const headers = {
    Authorization: props.user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  // Checker utility
  const checker = (state) => {
    const check = { icon: "check-circle", style: "null" };
    switch (state) {
      case true:
        check.icon = "check-circle";
        check.style = "correct";
        break;
      case false:
        check.icon = "times-circle";
        check.style = "wrong";
        break;
      default:
        break;
    }
    return check;
  };

  // Validate fields
  const validateFields = useCallback(() => {
    setForm((prev) => ({ ...prev, state: false }));
    if (field.name.state && field.levels.state) {
      setForm((prev) => ({ ...prev, state: true }));
    }
  }, [field]);

  // Validate all level states
  const valdidateLevelStates = useCallback(() => {
    const states = field.levels.value.filter((data) => data.state).length;
    if (field.levels.value.length === states) {
      setField((prev) => ({
        ...prev,
        levels: { ...prev.levels, state: true },
      }));
      validateFields();
    }
  }, [field.levels.value, validateFields]);

  // Handle input change
  const valueChanged = (event) => {
    const element = event.target;
    if (element.getAttribute("data-field")) {
      const fieldKey = element.getAttribute("data-field");
      const key = Number(element.getAttribute("data-key"));
      setField((prev) => {
        const value = prev[fieldKey].value.map((data, index) => {
          let newValue = element.value;
          if (element.id === "id") newValue = parseInt(element.value);
          if (index === key) {
            return { ...data, [element.id]: newValue };
          }
          return data;
        });
        return {
          ...prev,
          [fieldKey]: {
            ...prev[fieldKey],
            value,
            message: "",
            state: true,
          },
        };
      });
    } else {
      setField((prev) => ({
        ...prev,
        [element.id]: {
          ...prev[element.id],
          value: element.value,
          message: "",
          state: true,
        },
      }));
    }
    setForm((prev) => ({ ...prev, state: false }));
    checkField(element);
  };

  // Date change handler
  const dateChange = (date) => {
    setField((prev) => ({
      ...prev,
      accntExp: { ...prev.accntExp, value: date, state: true },
    }));
    setForm((prev) => ({ ...prev, state: true }));
  };

  // Check field logic
  const checkField = (data) => {
    clearTimeout(time.current);
    time.current = setTimeout(async () => {
      if (data.getAttribute("data-field")) {
        const fieldKey = data.getAttribute("data-field");
        const key = Number(data.getAttribute("data-key"));
        switch (fieldKey) {
          case "levels": {
            let state = true;
            let message = "";
            if (
              data.id === "name" &&
              field.levels.value[key].name.length <= 2
            ) {
              state = false;
              message = "level name should be minimum of 4 characters";
            }
            if (
              data.id === "id" &&
              (!field.levels.value[key].id ||
                field.levels.value[key].id < 1 ||
                typeof field.levels.value[key].id !== "number")
            ) {
              state = false;
              message = "user level should be on or between level 1 - 9";
            }
            if (
              data.id === "id" &&
              field.levels.value.filter(
                (value) => value.id === Number(data.value)
              ).length > 1 &&
              field.levels.value.length >= 2
            ) {
              state = false;
              message = "user level exist";
            }
            setField((prev) => {
              const value = prev.levels.value.map((v, idx) =>
                idx === key ? { ...v, message, state: true } : v
              );
              return {
                ...prev,
                levels: { ...prev.levels, value, message: "", state: true },
              };
            });
            valdidateLevelStates();
            break;
          }
          default:
            break;
        }
      } else {
        switch (data.id) {
          case "name": {
            if (data.value.length) {
              let state = true;
              let message = "";
              if (data.value.length <= 3) {
                state = false;
                message = "client name should be minimum of 4 characters \n";
              }
              try {
                const response = await axios.get(
                  props.chimeraserv.urlGet + "/group",
                  { headers }
                );
                if (
                  response.data.find((result) => {
                    return result.name === data.value && result._id !== id;
                  })
                ) {
                  state = false;
                  message = "client name already exist \n";
                }
              } catch {}
              setField((prev) => ({
                ...prev,
                name: {
                  ...prev.name,
                  value: data.value,
                  state,
                  message,
                },
              }));
              validateFields();
            }
            break;
          }
          default:
            break;
        }
      }
    }, 500);
  };

  // Add new level
  const add = () => {
    setField((prev) => ({
      ...prev,
      levels: {
        ...prev.levels,
        value: [
          ...prev.levels.value,
          {
            id: parseInt(prev.levels.value.length + 1),
            name: "",
            state: null,
          },
        ],
        message: "",
        state: null,
      },
    }));
    valdidateLevelStates();
  };

  // Remove level
  const remove = (key) => {
    setField((prev) => ({
      ...prev,
      levels: {
        ...prev.levels,
        value: prev.levels.value.filter((_, idx) => idx !== key),
        message: "",
        state: null,
      },
    }));
    valdidateLevelStates();
  };

  // Reset handler
  const resetHandler = () => {
    setReset(new Date().getTime());
    setField({
      name: { value: "", message: "", state: null },
      levels: {
        value: [{ id: 1, name: "Admin", state: true }],
        message: "",
        state: true,
      },
      accntExp: { value: new Date(), message: "", state: true },
    });
    setForm({ state: null, message: "" });
    setSelectedCurrency(currencies[0]);
    loadData();
  };

  // Submit handler

  const submit = async () => {
    setForm((prev) => ({ ...prev, state: false, message: "" }));
    try {
      // Ensure we have data to update
      if (!data || data.length === 0) {
        throw new Error("No group data available to update");
      }

      const response = await axios.put(
        // Changed from POST to PUT
        `${props.chimeraserv.urlPost}/group/update`,
        {
          _id: data[0]._id, // Include the ID for update
          grpKey: data[0].grpKey,
          name: field.name.value,
          levels: field.levels.value,
          accntExp: Math.floor(field.accntExp.value.getTime() / 1000),
          baseCurr: selectedCurrency,
        },
        {
          headers: {
            Authorization: props.user.data.usrKey,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && !response.data.__v) {
        setForm((prev) => ({
          ...prev,
          message: "Group Updated Successfully", // Changed message
        }));
      }
    } catch (error) {
      console.error("Submit error:", error);
      setForm((prev) => ({
        ...prev,
        message: error.message || "Error updating group",
      }));
    }
  };

  // Handle currency change
  const handleCurrencyChange = (e) => {
    setSelectedCurrency(e.target.value);
  };

  const loadData = useCallback(async () => {
    try {
      // Check if we have group data from navigation state first
      if (location.state && location.state.groupData) {
        const groupData = location.state.groupData;

        setData([groupData]);
        const levelsWithState = (groupData.levels || []).map((level) => ({
          ...level,
          state: level.name && level.name.length > 3 ? true : false,
        }));
        setField((prev) => ({
          ...prev,
          name: { ...prev.name, value: groupData.name, state: true },
          levels: {
            ...prev.levels,
            value: levelsWithState,
            state: true,
          },
          // Properly convert the date string to Date object
          accntExp: {
            ...prev.accntExp,
            value: groupData.accntExp
              ? new Date(groupData.accntExp * 1000)
              : new Date(),
            state: true,
          },
        }));

        // Set currency if available
        if (groupData.baseCurr) {
          setSelectedCurrency(groupData.baseCurr);
        }

        setLoad(true);
        return;
      }

      // Fallback: fetch from API
      const response = await axios.get(
        props.chimeraserv.urlGet + "/group/" + id,
        { headers }
      );

      const filteredData = response.data.filter((d) => d._id === id);
      setData(filteredData);

      if (filteredData.length > 0) {
        const groupData = filteredData[0];
        const levelsWithState = (groupData.levels || []).map((level) => ({
          ...level,
          state: level.name && level.name.length > 3 ? true : false,
        }));
        setField((prev) => ({
          ...prev,
          name: { ...prev.name, value: groupData.name, state: true },
          levels: { ...prev.levels, value: levelsWithState, state: true },
          // Properly convert the date string to Date object
          accntExp: {
            ...prev.accntExp,
            value: groupData.accntExp
              ? new Date(groupData.accntExp * 1000)
              : new Date(),
            state: true,
          },
        }));

        // Set currency if available
        if (groupData.baseCurr) {
          setSelectedCurrency(groupData.baseCurr);
        }
      }

      setLoad(true);
    } catch (error) {
      console.error("Error loading group data:", error);
      setData([]);
      setLoad(true);
    }
  }, [props.chimeraserv.urlGet, id, headers.Authorization, location.state]);

  // useEffect(() => {
  //   if (data.length > 0 && data[0]._id) {
  //     loadUserData(data[0]._id);
  //   }
  // }, [data, loadUserData]);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line
  }, [loadData]);
  // Render
  return (
    <div className={"custForm"}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className={["viewTitle"]}>Edit Client</div>
      <form onSubmit={(e) => e.preventDefault()} className={["form"]}>
        <div className={["form-group"]}>
          <label>
            Client Name <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(field.name.state).style].join(" ")}
            icon={["fas", checker(field.name.state).icon]}
          />
          <div className={["field"]}>
            <input
              type={"text"}
              className={["form-control"]}
              id={"name"}
              placeholder={"enter client name"}
              value={field.name.value}
              onChange={valueChanged}
            />
            <span>{field.name.message}</span>
          </div>
        </div>

        <div className={["form-group"]}>
          <label htmlFor="group">
            Base currency <span>*</span>
          </label>
          <FontAwesomeIcon
            className={"icon correct"}
            icon={["fas", "check-circle"]}
          />
          <select
            className="form-control"
            id="group"
            onChange={handleCurrencyChange}
            value={selectedCurrency}
          >
            {currencies.map((item) => (
              <option value={item} key={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        <div className={["form-group"]}>
          <label>
            User levels <span>*</span>
          </label>
          <div className={"multipart"}>
            {field.levels.value.map((data, key) => (
              <div className={["field"]} key={key}>
                <div className={"part"}>
                  <FontAwesomeIcon
                    className={["icon", checker(data.state).style].join(" ")}
                    icon={["fas", checker(data.state).icon]}
                  />
                  <input
                    type={"number"}
                    className={["form-control", "level"].join(" ")}
                    id={"id"}
                    placeholder={"level"}
                    value={data.id}
                    data-key={key}
                    onChange={valueChanged}
                    data-field={"levels"}
                  />
                  <input
                    type={"text"}
                    className={["form-control", "custField"].join(" ")}
                    id={"name"}
                    placeholder={"enter level name"}
                    value={data.name}
                    data-key={key}
                    onChange={valueChanged}
                    data-field={"levels"}
                  />

                  <button
                    type={"button"}
                    onClick={() => (key === 0 ? add() : remove(key))}
                    className={["custBtn", key === 0 ? "add" : "remove"].join(
                      " "
                    )}
                  >
                    <FontAwesomeIcon
                      className={[
                        "icon",
                        checker(field.levels.state).style,
                      ].join(" ")}
                      icon={key === 0 ? "plus" : "minus"}
                    />
                  </button>
                </div>
                <span>{data.message}</span>
              </div>
            ))}
          </div>
        </div>
        <div className={["form-group"]}>
          <label>
            Account Expiration <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(field.accntExp.state).style].join(" ")}
            icon={["fas", checker(field.accntExp.state).icon]}
          />
          <div className={["date"].join(" ")}>
            <DatePicker
              className={["form-control"]}
              selected={field.accntExp.value} // Use the Date object directly
              onChange={dateChange}
              dateFormat="dd/MM/yyyy" // Add date format for display
              placeholderText="Select expiration date"
            />
          </div>
        </div>
        {form.message ? (
          <div className={["message", "form-group"].join(" ")}>
            <FontAwesomeIcon
              className={["icon", "correct"].join(" ")}
              icon={"check-circle"}
            />
            {form.message}
          </div>
        ) : (
          <div />
        )}
        <button
          type={"button"}
          className={["btn btn-primary"]}
          disabled={!form.state}
          onClick={submit}
        >
          Save
        </button>
        <button
          type={"button"}
          onClick={resetHandler}
          className={["btn btn-primary", "reset"].join(" ")}
        >
          Reset
        </button>
      </form>
    </div>
  );
}

export default EditGroup;
